import React from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

import { logoutUser, logoutUserSagas } from '../Login/actions';
import { USER_UNSET } from '../Login/constants';

const Logout = class extends React.Component {
  componentWillMount() {
    this.props.dispatch(logoutUserSagas());
    this.props.dispatch(logoutUser());
    this.props.dispatch({ type: USER_UNSET });
    browserHistory.replace('login/#/logout');
  }

  render() {
    return null;
  }
};

export default connect()(Logout);
